import { _ as __rest } from '../../../tslib.es6-C8rd5pYo.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Icon } from '../../display/Icon/Icon.es.js';
import { Tooltip } from '../../display/Tooltip/Tooltip.es.js';
import { TextInput } from '../TextInput/TextInput.es.js';
import 'react';
import { useCopyToClipboard } from '../../../hooks/useCopyToClipboard.es.js';

const root = "_root_tbbib_1";
const copyButton = "_copy-button_tbbib_6";
const tooltip = "_tooltip_tbbib_22";
const styles = {
	root: root,
	copyButton: copyButton,
	tooltip: tooltip
};

const CopyTextInput = (_a) => {
  var { size = "medium", type = "text", value } = _a, otherProps = __rest(_a, ["size", "type", "value"]);
  const props = Object.assign({
    size,
    type,
    value
  }, otherProps);
  const [didCopy, handleCopyText] = useCopyToClipboard(value);
  const onClickCopy = (event) => {
    event.preventDefault();
    handleCopyText();
  };
  const renderCopyButton = ({ iconSize }) => {
    const ariaLabel = didCopy ? `"${value}" copied to the clipboard` : `Copy "${value}" to the clipboard`;
    return jsxs("button", { "aria-hidden": !value, "aria-label": ariaLabel, className: styles.copyButton, color: "primary", disabled: !value, onClick: onClickCopy, type: "button", "data-zds": true, children: [jsx(Icon, { isBlock: true, name: "actionCopy", size: iconSize }), jsx("div", { className: styles.tooltip, "data-hidden": !didCopy, "data-zds": true, children: jsx(Tooltip, { "aria-hidden": true, position: "southeast", children: "Copied to clipboard!" }) })] });
  };
  return jsx("div", { className: styles.root, "data-zds": true, children: jsx(TextInput, Object.assign({}, props, { "aria-hidden": true, disabledText: value ? "" : "Disabled", isDisabled: !value, isReadonly: Boolean(value), isFocusable: false, renderIconAfter: renderCopyButton })) });
};

export { CopyTextInput };
//# sourceMappingURL=CopyTextInput.es.js.map
